import {React, useContext} from 'external/react'
import {styled, Box, clsx, Fade} from 'external/material'
import {getYear} from 'external/date-fns'

import {TeacherContext} from 'teacher/context'
import ExportRollbookButton from './ExportRollbook'

const StyledInfoBar = styled(Box)(infoBarStyles)

export default function InfoBar () {
  const {profile, translate, rollbookContextPeriods} = useContext(TeacherContext)
  const {loaded, items} = rollbookContextPeriods
  const firstAndLast = loaded && items.length > 0
    ? [items[0], items[items.length - 1]]
    : [{start: ''}, {finish: ''}]
  const [{start}, {finish}] = firstAndLast

  const startYear = getYear(start)
  const finishYear = getYear(finish)

  const label = `${translate('rollbook')} ${startYear} - ${finishYear}`
  const validYear = !(isNaN(startYear) || isNaN(finishYear))

  //const isDreyfous = profile.domain === 'dreyfous' || profile.domain === 'dreyfous-dg'

  return (
    <StyledInfoBar>
      <Fade in={validYear} timeout={{exit: 0}}>
        <Box className={clsx('container', 'label')}>{label}</Box>
      </Fade>
      <Box sx={{flexGrow: 1}} />
       <Box className={clsx('container', 'export-button')}>
        <ExportRollbookButton rollbookLabel={label} />
      </Box>
    </StyledInfoBar>
  )
}

function infoBarStyles() {
  return {
    display: 'flex',
    padding: '5px 20px',
    borderBottom: 'solid 1px #dbe3e6',
    minHeight: 60,
    '& > .container': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    '& .label': {
      color: '#636b80',
      fontWeight: 'bold',
      fontSize: '12pt'
    },
  }
}
